module.exports = __webpack_public_path__ + "img/icon-student.8229f5dc.svg";